var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    {
      staticClass: "roleDetails",
      staticStyle: { background: "rgba(236,236,236,1)", overflow: "hidden" },
      attrs: { id: "inspire" }
    },
    [
      _vm.isToolbarVisible
        ? _c(
            "v-toolbar",
            {
              staticStyle: { "z-index": "200" },
              attrs: { "clipped-right": "", fixed: "" }
            },
            [
              !_vm.collapse
                ? _c("img", {
                    staticClass: "headerImg",
                    attrs: { src: _vm.logo },
                    on: {
                      click: function($event) {
                        return _vm.gotoDataScreening()
                      }
                    }
                  })
                : _c("img", {
                    class: _vm.collapse ? "isTranslate" : "noTranslate",
                    attrs: { width: "40px", src: _vm.logoMini },
                    on: {
                      click: function($event) {
                        return _vm.gotoDataScreening()
                      }
                    }
                  }),
              _vm._v(" "),
              _vm.decideRoute().show
                ? _c("span", { staticStyle: { "margin-left": "4.5%" } }, [
                    _c("b", { staticStyle: { "font-size": "20px" } }, [
                      _vm._v(_vm._s(_vm.decideRoute().title))
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "el-popover",
                {
                  attrs: {
                    id: "searchPopver",
                    placement: "bottom",
                    width: "300"
                  },
                  model: {
                    value: _vm.isShowDept,
                    callback: function($$v) {
                      _vm.isShowDept = $$v
                    },
                    expression: "isShowDept"
                  }
                },
                [
                  _c(
                    "el-input",
                    {
                      staticStyle: {
                        border: "0",
                        "font-size": "18px",
                        "font-weight": "600"
                      },
                      attrs: {
                        slot: "reference",
                        id: "searchDept",
                        "suffix-icon": "el-icon-caret-bottom"
                      },
                      slot: "reference",
                      model: {
                        value: _vm.filterText,
                        callback: function($$v) {
                          _vm.filterText = $$v
                        },
                        expression: "filterText"
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "el-icon-refresh",
                        staticStyle: { color: "#000" },
                        attrs: { slot: "suffix" },
                        on: { click: _vm.resetDeptFilter },
                        slot: "suffix"
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { height: "200px", "overflow-y": "auto" } },
                    [
                      _c("el-tree", {
                        ref: "deptTree",
                        attrs: {
                          "check-on-click-node": true,
                          data: _vm.queryDept,
                          "expand-on-click-node": false,
                          props: _vm.defaultProps,
                          "filter-node-method": _vm.filterNode,
                          accordion: ""
                        },
                        on: { "node-click": _vm.handleNodeClick }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-popover",
                {
                  attrs: {
                    placement: "bottom",
                    width: "400",
                    trigger: "click"
                  },
                  model: {
                    value: _vm.showMessageFlag,
                    callback: function($$v) {
                      _vm.showMessageFlag = $$v
                    },
                    expression: "showMessageFlag"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { margin: "0 15px" },
                      attrs: { slot: "reference" },
                      slot: "reference"
                    },
                    [
                      _vm.getMessageListCount > 0 && _vm.showBadge
                        ? _c(
                            "el-badge",
                            { attrs: { value: _vm.getMessageListCount } },
                            [
                              _c(
                                "el-button",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.readAllMessage()
                                    }
                                  }
                                },
                                [_vm._v("通知")]
                              )
                            ],
                            1
                          )
                        : _c(
                            "div",
                            [
                              _c(
                                "el-button",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.readAllMessage()
                                    }
                                  }
                                },
                                [_vm._v("通知")]
                              )
                            ],
                            1
                          )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        height: "420px",
                        display: "flex",
                        "justify-content": "space-between",
                        "flex-direction": "column"
                      },
                      on: { click: _vm.goMessageInfo }
                    },
                    [
                      _c("noData", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: this.getMessageInfo.length == 0,
                            expression: "this.getMessageInfo.length == 0"
                          }
                        ],
                        attrs: { width: "200px", height: "200px" }
                      }),
                      _vm._v(" "),
                      _c(
                        "v-list",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: this.getMessageInfo.length != 0,
                              expression: "this.getMessageInfo.length != 0"
                            }
                          ],
                          attrs: { "two-line": "" }
                        },
                        [
                          _vm._l(this.getMessageInfo, function(item, index) {
                            return [
                              _c(
                                "v-list-tile",
                                { key: item.createTime, attrs: { avatar: "" } },
                                [
                                  _c(
                                    "el-tooltip",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        effect: "dark",
                                        content: item.text,
                                        placement: "left"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-list-tile-content",
                                        {},
                                        [
                                          _c("v-list-tile-title", {
                                            staticClass: "text-overflow",
                                            staticStyle: { width: "220px" },
                                            domProps: {
                                              innerHTML: _vm._s(item.title)
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("v-list-tile-sub-title", {
                                            domProps: {
                                              innerHTML: _vm._s(item.createTime)
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-action",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "center"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-expand-transition",
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              staticStyle: { "z-index": "100" },
                                              attrs: { size: "small" },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.gotoDetails(
                                                    item.msgId
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("查看详情")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-action",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "center",
                                        "z-index": "100"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-expand-transition",
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: { icon: "", ripple: "" },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.unRead(item)
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { color: "pink" } },
                                                [_vm._v("delete")]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: this.getMessageInfo.length != 0,
                              expression: "this.getMessageInfo.length != 0"
                            }
                          ],
                          staticStyle: { width: "100%" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.goMessageInfo($event)
                            }
                          }
                        },
                        [_vm._v("查看更多")]
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-popover",
                {
                  attrs: {
                    placement: "bottom",
                    width: "400",
                    trigger: "click"
                  },
                  model: {
                    value: _vm.showTodoFlag,
                    callback: function($$v) {
                      _vm.showTodoFlag = $$v
                    },
                    expression: "showTodoFlag"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { margin: "0 15px" },
                      attrs: { slot: "reference" },
                      slot: "reference"
                    },
                    [
                      _vm.getTodoListCount > 0
                        ? _c(
                            "el-badge",
                            { attrs: { value: _vm.getTodoListCount } },
                            [_c("el-button", [_vm._v("待办")])],
                            1
                          )
                        : _c("div", [_c("el-button", [_vm._v("待办")])], 1)
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      ref: "parentElm",
                      staticStyle: {
                        height: "350px",
                        display: "flex",
                        "justify-content": "space-between",
                        "flex-direction": "column"
                      }
                    },
                    [
                      _c("noData", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: this.getTodoList.length == 0,
                            expression: "this.getTodoList.length == 0"
                          }
                        ],
                        attrs: { width: "200px", height: "200px" }
                      }),
                      _vm._v(" "),
                      _c(
                        "v-list",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: this.getTodoList.length != 0,
                              expression: "this.getTodoList.length != 0"
                            }
                          ],
                          attrs: { "two-line": "" }
                        },
                        [
                          _vm._l(this.getTodoList, function(item, index) {
                            return [
                              _c(
                                "v-list-tile",
                                {
                                  key: index,
                                  attrs: { avatar: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.clickTodoList(item)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-list-tile-action",
                                    [_c("v-icon", [_vm._v("hourglass_full")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-tooltip",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        effect: "dark",
                                        content: item.text,
                                        placement: "left"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-list-tile-content",
                                        [
                                          _c(
                                            "v-list-tile-title",
                                            {
                                              staticClass: "text-overflow",
                                              staticStyle: { width: "220px" }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(item.text) +
                                                  "\n                    "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("v-list-tile-sub-title", [
                                            _vm._v(_vm._s(item.createTime))
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  item.text && item.text.indexOf("制度文件") > 0
                                    ? _c(
                                        "el-button",
                                        {
                                          staticStyle: {
                                            "padding-left": "5px",
                                            "padding-right": "5px"
                                          },
                                          attrs: { size: "mini" }
                                        },
                                        [_vm._v("点击查看")]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: this.getTodoList.length != 0,
                              expression: "this.getTodoList.length != 0"
                            }
                          ],
                          staticStyle: { width: "100%" },
                          on: { click: _vm.goTodoList }
                        },
                        [_vm._v("查看更多\n          ")]
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-popover",
                {
                  attrs: {
                    placement: "bottom",
                    width: "200",
                    trigger: "click"
                  },
                  model: {
                    value: _vm.headPopover,
                    callback: function($$v) {
                      _vm.headPopover = $$v
                    },
                    expression: "headPopover"
                  }
                },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { slot: "reference", icon: "", large: "" },
                      slot: "reference"
                    },
                    [
                      _c(
                        "v-avatar",
                        { attrs: { size: "32px" } },
                        [
                          _vm.headImg
                            ? _c(
                                "v-img",
                                {
                                  staticClass: "grey lighten-2",
                                  attrs: {
                                    src: _vm.headImg,
                                    "lazy-src":
                                      "https://picsum.photos/10/6?image=" +
                                      (1 * 5 + 10),
                                    "aspect-ratio": "1",
                                    alt: "暂无"
                                  }
                                },
                                [
                                  _c(
                                    "v-layout",
                                    {
                                      attrs: {
                                        slot: "placeholder",
                                        "fill-height": "",
                                        "align-center": "",
                                        "justify-center": "",
                                        "ma-0": ""
                                      },
                                      slot: "placeholder"
                                    },
                                    [
                                      _c("v-progress-circular", {
                                        attrs: {
                                          indeterminate: "",
                                          color: "grey lighten-5"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _c(
                                "v-img",
                                {
                                  staticClass: "grey lighten-2",
                                  attrs: {
                                    src:
                                      _vm.sex == 0
                                        ? _vm.logoMiniMan
                                        : _vm.logoMiniWomen,
                                    "lazy-src":
                                      "https://picsum.photos/10/6?image=" +
                                      (1 * 5 + 10),
                                    "aspect-ratio": "1",
                                    alt: "暂无"
                                  }
                                },
                                [
                                  _c(
                                    "v-layout",
                                    {
                                      attrs: {
                                        slot: "placeholder",
                                        "fill-height": "",
                                        "align-center": "",
                                        "justify-center": "",
                                        "ma-0": ""
                                      },
                                      slot: "placeholder"
                                    },
                                    [
                                      _c("v-progress-circular", {
                                        attrs: {
                                          indeterminate: "",
                                          color: "grey lighten-5"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list",
                    { staticStyle: { "text-align": "center" } },
                    _vm._l(_vm.arr, function(item, index) {
                      return _c(
                        "v-list-tile",
                        {
                          key: index,
                          on: {
                            click: function($event) {
                              return _vm.personalCenter(item.router)
                            }
                          }
                        },
                        [
                          _c(
                            "v-list-tile-action",
                            [_c("v-icon", [_vm._v(_vm._s(item.icon))])],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-list-tile-title", [_vm._v(_vm._s(item.title))])
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "text-overflow",
                  staticStyle: { "text-align": "left", "max-width": "150px" }
                },
                [
                  _c("strong", {
                    domProps: { innerHTML: _vm._s(_vm.nameSlot) }
                  })
                ]
              ),
              _vm._v(" "),
              _c("ThemePicker"),
              _vm._v(" "),
              _c("LangSelect")
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-card",
        {
          staticStyle: {
            "font-size": "16px",
            width: "100%",
            display: "flex",
            "justify-content": "space-between",
            position: "relative"
          }
        },
        [
          !_vm.collapse
            ? _c(
                "el-menu",
                {
                  staticClass: "el-menu-vertical-demo scroll",
                  staticStyle: {
                    "margin-bottom": "500px",
                    "padding-bottom": "500px",
                    top: "64px",
                    left: "0",
                    "z-index": "120",
                    position: "fixed",
                    height: "100vh",
                    "overflow-y": "auto"
                  },
                  attrs: {
                    collapse: _vm.collapse,
                    "default-active": _vm.activeIndex,
                    "unique-opened": "",
                    router: "",
                    "text-color": "#004ea1",
                    "active-text-color": "#f60"
                  },
                  on: {
                    open: function($event) {
                      _vm.active = true
                    },
                    close: function($event) {
                      _vm.active = false
                    },
                    select: _vm.selectItem
                  }
                },
                [
                  _c("verticalMenuItem", {
                    attrs: {
                      isCollapse: _vm.collapse,
                      arr: _vm.$t("list"),
                      "show-icon": true,
                      idx: 0
                    },
                    on: { confirm: _vm.confirmChoose }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              class: _vm.collapse ? "left-10" : "left-260",
              staticStyle: {
                "border-radius": "50%",
                border: "1px solid transparent",
                position: "fixed",
                left: "260px",
                "z-index": "120",
                top: "50%",
                transform: "translateY(-50%)",
                background: "#fff",
                display: "flex",
                "justify-content": "center",
                "align-items": "center"
              }
            },
            [
              _c(
                "v-icon",
                {
                  staticStyle: { color: "#156ac3" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.clickSlide($event)
                    }
                  }
                },
                [_vm._v("swap_horiz")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-content",
            {
              staticClass: "scroll",
              class: _vm.getNewClass(),
              staticStyle: { position: "relative" }
            },
            [
              _c(
                "el-popover",
                {
                  attrs: {
                    "popper-class": "tips",
                    width: "210",
                    placement: "left",
                    trigger: "click"
                  }
                },
                [
                  _c("div", [
                    _c("div", [_vm._v("如有疑问，请联系客服")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "text-align": "left",
                          "margin-top": "5px"
                        }
                      },
                      [
                        _vm._v("客服电话："),
                        _c("span", { staticStyle: { color: "#007AFF" } }, [
                          _vm._v("400-8080-150")
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "round-btn",
                      staticStyle: { bottom: "250px" },
                      attrs: {
                        slot: "reference",
                        fixed: "",
                        fab: "",
                        bottom: "",
                        right: "",
                        small: ""
                      },
                      slot: "reference"
                    },
                    [_c("span", { staticClass: "iconfont-phone" })]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-popover",
                {
                  staticStyle: { padding: "0" },
                  attrs: {
                    "popper-class": "tips",
                    width: "250",
                    trigger: "click"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "column",
                        "align-items": "center",
                        "justify-content": "center"
                      }
                    },
                    [
                      _c("h3", { staticClass: "text-md-center mb-2" }, [
                        _vm._v("下载EMP系统App")
                      ]),
                      _vm._v(" "),
                      _c("img", {
                        staticStyle: { width: "180px", height: "180px" },
                        attrs: { src: _vm.apkQrcodeImg }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "grey--text",
                          staticStyle: { "font-size": "12px" }
                        },
                        [_vm._v("请使用手机浏览器扫描二维码下载")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "round-btn",
                      staticStyle: { bottom: "180px" },
                      attrs: {
                        slot: "reference",
                        fab: "",
                        bottom: "",
                        right: "",
                        small: ""
                      },
                      on: {
                        click: function($event) {
                          return _vm.getApkQrcodeImg(1)
                        }
                      },
                      slot: "reference"
                    },
                    [_c("span", { staticClass: "iconfont-mobile" })]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  ref: "box",
                  staticStyle: { padding: "0px", width: "100%", height: "100%" }
                },
                [
                  _c(
                    "keep-alive",
                    {
                      attrs: {
                        exclude: "vehicleVideo, vehiclReplay, createPayCollect"
                      }
                    },
                    [
                      _c("router-view", {
                        key: _vm.$route.fullPath,
                        staticClass: "router",
                        attrs: {
                          "p-user": _vm.pUser,
                          roles: _vm.roles,
                          "p-data": _vm.pData,
                          paramsDeptId: _vm.deptId
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("messageInfo", { on: { getUnreadMsg: _vm.getUnreadMsg } })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              attrs: { width: "500" },
              model: {
                value: _vm.changeDeptDialog,
                callback: function($$v) {
                  _vm.changeDeptDialog = $$v
                },
                expression: "changeDeptDialog"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    {
                      staticClass: "headline lighten-2",
                      attrs: { "primary-title": "" }
                    },
                    [_vm._v("\n            请切换部门\n          ")]
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择部门" },
                          model: {
                            value: _vm.userDept,
                            callback: function($$v) {
                              _vm.userDept = $$v
                            },
                            expression: "userDept"
                          }
                        },
                        _vm._l(_vm.getUserDepts, function(item) {
                          return _c("el-option", {
                            key: item.deptId,
                            attrs: {
                              label: item.deptAllName,
                              value: item.deptId
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              _vm.changeDeptDialog = false
                            }
                          }
                        },
                        [_vm._v("取消")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.submitSwitchDept }
                        },
                        [_vm._v("确认")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("chat-dialog", { ref: "chatDialog" }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "custom-dialog",
          attrs: {
            title: "温馨提示",
            "close-on-click-modal": false,
            width: "600px",
            visible: _vm.dialogV2
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogV2 = $event
            }
          }
        },
        [
          [
            _c(
              "div",
              { staticStyle: { margin: "50px 80px", height: "100px" } },
              [
                _vm._v(
                  "\n          尊敬用户您好！系统为了响应工程局的信息安全要求进行升级，\n          您的登录密码必须满足字母+数字的组合，长度在8位数及以上。为了便于您正常使用系统，请您及时修改密码！\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticStyle: { padding: "12px 20px" },
                attrs: { type: "primary" },
                on: { click: _vm.closeDialog }
              },
              [_vm._v("确 定")]
            )
          ]
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "custom-dialog",
          attrs: {
            title: "温馨提示",
            "close-on-click-modal": false,
            width: "600px",
            visible: _vm.dialogV3
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogV3 = $event
            }
          }
        },
        [
          [
            _c(
              "div",
              { staticStyle: { margin: "50px 80px", height: "100px" } },
              [
                _vm._v(
                  "\n          尊敬用户您好！系统为了响应工程局的信息安全要求，并保障您的账户安全，您的密码于 [" +
                    _vm._s(_vm.pwdUpdateAt) +
                    "] 到期。请及时修改密码。"
                ),
                _c("br"),
                _vm._v("\n          感谢您的理解与配合！\n        ")
              ]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticStyle: { padding: "12px 20px" },
                attrs: { type: "primary" },
                on: { click: _vm.closeDialog }
              },
              [_vm._v("确 定")]
            )
          ]
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "custom-dialog",
          attrs: {
            title: "温馨提示",
            width: "700px",
            visible: _vm.inAuditDialog
          },
          on: {
            "update:visible": function($event) {
              _vm.inAuditDialog = $event
            }
          }
        },
        [
          _c(
            "p",
            { staticStyle: { "font-size": "16px", "text-align": "left" } },
            [_vm._v(_vm._s(_vm.detail ? _vm.detail.content : ""))]
          ),
          _vm._v(" "),
          _vm.detail && "TRUE_FALSE" == _vm.detail.category
            ? _c(
                "p",
                { staticStyle: { "font-size": "16px", "text-align": "left" } },
                [_vm._v("答案：" + _vm._s(_vm.detail.correctAnswer))]
              )
            : [
                _vm.detail
                  ? _c(
                      "div",
                      { staticStyle: { "text-align": "left" } },
                      _vm._l(_vm.detail.options, function(item2, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "grid-item" },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(item2.optionKey) +
                                ":" +
                                _vm._s(item2.optionContent) +
                                "\n\t\t\t\t"
                            )
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.detail
                  ? _c(
                      "p",
                      {
                        staticStyle: {
                          "font-size": "16px",
                          "text-align": "left"
                        }
                      },
                      [_vm._v("答案：" + _vm._s(_vm.detail.correctAnswer))]
                    )
                  : _vm._e()
              ],
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              staticStyle: { "text-align": "center" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { width: "80px", height: "40px" },
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.auditSubmit()
                    }
                  }
                },
                [_vm._v(" 确 认")]
              )
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }